import React from "react";
import * as Icons from "lucide-react";
import { Reveal, RevealGroup, RevealItem } from "@/components/common/Reveal";
import SectionLabel from "@/components/common/SectionLabel";
import Counter from "@/components/common/Counter";
import { STRENGTHS } from "@/data/site";

export default function Strengths() {
  return (
    <section data-testid="strengths-section" className="bg-gema-ink py-24 md:py-32 border-t border-white/5">
      <div className="container-gema">
        <Reveal>
          <SectionLabel index="02">¿Por qué elegir GEMA?</SectionLabel>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="heading-lg text-white mt-6 max-w-3xl">
            Cuatro razones que respaldan nuestro trabajo
          </h2>
        </Reveal>

        <RevealGroup className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px mt-16 bg-white/10 border border-white/10">
          {STRENGTHS.map((s) => {
            const Icon = Icons[s.icon] || Icons.CheckCircle2;
            return (
              <RevealItem key={s.title}>
                <div
                  data-testid={`strength-${s.title.toLowerCase().replace(/\s+/g, "-")}`}
                  className="group bg-gema-ink p-8 lg:p-10 h-full transition-colors duration-300 hover:bg-gema-surface"
                >
                  <Icon className="h-9 w-9 text-gema-red" strokeWidth={1.5} />
                  <div className="mt-8 flex items-baseline gap-1">
                    <Counter to={s.stat} suffix={s.statSuffix} className="font-heading font-black text-4xl text-white" />
                  </div>
                  <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-white/40 mt-1">{s.statLabel}</p>
                  <h3 className="font-heading font-bold uppercase text-lg text-white mt-6">{s.title}</h3>
                  <p className="text-white/50 text-sm mt-3 leading-relaxed">{s.text}</p>
                </div>
              </RevealItem>
            );
          })}
        </RevealGroup>
      </div>
    </section>
  );
}
